/**
 * Theme Initialization Script
 * Consolidated from inline scripts in theme.liquid for better caching
 * This file is cacheable by Shopify CDN (max-age=31536000)
 */

// Theme Settings (populated by Liquid in theme.liquid via data attribute)
(function() {
  const themeData = document.getElementById('theme-init-data');
  if (themeData) {
    try {
      const data = JSON.parse(themeData.textContent);
      
      // Theme Settings
      window.themeSettings = data.themeSettings || {};
      
      // Constructor.io
      window.cnstrc = window.cnstrc || {};
      window.cnstrc.testCell = data.constructorTestCell || 'variant';
      if (data.constructorUserId) {
        window.cnstrc.userId = data.constructorUserId;
      }
      
      // UXA tracking
      window._uxa = window._uxa || [];
      window._uxa.push(['setCustomVariable', {
        name: 'constructor_test_cell',
        value: window.cnstrc.testCell,
        scope: 'session'
      }]);
    } catch (e) {
      console.error('Theme init error:', e);
    }
  }
})();

// Collections index redirect (prevent loop)
(function() {
  var path = window.location.pathname.replace(/\/+$/, '');
  var isCollectionsIndex =
    path === '/collections' ||
    /^\/[a-z]{2}(-[a-z]{2})?\/collections$/i.test(path);
  
  if (!isCollectionsIndex) return;
  if (sessionStorage.getItem('redirected_collections_index') === '1') return;
  
  sessionStorage.setItem('redirected_collections_index', '1');
  window.location.replace('/');
})();

// iOS detection
(function() {
  if (/iP(ad|hone|od)/.test(navigator.userAgent)) {
    document.documentElement.classList.add('is-ios');
  }
})();

// Temporary storage-clear monitor/guard for popup/session reset debugging.
// Toggle blocking by setting window.__blockStorageClear = true before scripts run.
(function() {
  if (window.__storageClearMonitorInstalled) return;
  window.__storageClearMonitorInstalled = true;

  if (!window.Storage || !window.Storage.prototype) return;

  var originalClear = window.Storage.prototype.clear;
  var originalRemoveItem = window.Storage.prototype.removeItem;
  if (typeof originalClear !== 'function') return;

  window.__storageClearCalls = window.__storageClearCalls || [];
  window.__storageRemoveItemCalls = window.__storageRemoveItemCalls || [];

  function getStorageType(storageRef) {
    return storageRef === window.localStorage
      ? 'localStorage'
      : storageRef === window.sessionStorage
        ? 'sessionStorage'
        : 'unknownStorage';
  }

  var STORAGE_REMOVE_MONITOR_KEY_REGEX = /(attentive|attn|popup|bopis|pickup|location|geo|geolocation|permission|consent|privacy|declin|dismiss|submit|seen)/i;

  window.Storage.prototype.clear = function() {
    var storageType = getStorageType(this);

    var blocked = window.__blockStorageClear === true;
    var call = {
      storageType: storageType,
      blocked: blocked,
      href: window.location.href,
      ts: Date.now(),
      stack: new Error('[storage-clear-monitor] ' + storageType + '.clear() called').stack
    };

    try {
      window.__storageClearCalls.push(call);
      if (window.__storageClearCalls.length > 50) {
        window.__storageClearCalls.shift();
      }
    } catch (e) {}

    try {
      window.dispatchEvent(new CustomEvent('storage:clear:attempt', { detail: call }));
    } catch (e) {}

    console.warn('[storage-clear-monitor] ' + storageType + '.clear() called', call);

    if (blocked) {
      console.warn('[storage-clear-monitor] blocked ' + storageType + '.clear()');
      return;
    }

    return originalClear.apply(this, arguments);
  };

  if (typeof originalRemoveItem === 'function') {
    window.Storage.prototype.removeItem = function(key) {
      var keyName = key == null ? '' : String(key);
      var shouldTrack = STORAGE_REMOVE_MONITOR_KEY_REGEX.test(keyName);

      if (!shouldTrack) {
        return originalRemoveItem.apply(this, arguments);
      }

      var storageType = getStorageType(this);
      var blocked = window.__blockStorageRemoveItem === true;
      var call = {
        storageType: storageType,
        key: keyName,
        blocked: blocked,
        href: window.location.href,
        ts: Date.now(),
        stack: new Error('[storage-remove-item-monitor] ' + storageType + '.removeItem("' + keyName + '") called').stack
      };

      try {
        window.__storageRemoveItemCalls.push(call);
        if (window.__storageRemoveItemCalls.length > 200) {
          window.__storageRemoveItemCalls.shift();
        }
      } catch (e) {}

      try {
        window.dispatchEvent(new CustomEvent('storage:remove-item:attempt', { detail: call }));
      } catch (e) {}

      console.warn('[storage-remove-item-monitor] ' + storageType + '.removeItem("' + keyName + '") called', call);

      if (blocked) {
        console.warn('[storage-remove-item-monitor] blocked ' + storageType + '.removeItem("' + keyName + '")');
        return;
      }

      return originalRemoveItem.apply(this, arguments);
    };
  }
})();

// Klaviyo identification (deferred)
function initKlaviyo(customerEmail) {
  if (!customerEmail) return;
  
  function identifyKlaviyoUser() {
    if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
      try {
        window.klaviyo.identify({"$email": customerEmail});
      } catch (error) {
        console.warn('Klaviyo identify error:', error);
      }
    } else if (window.klaviyo && Array.isArray(window.klaviyo)) {
      window.klaviyo.push(['identify', {"$email": customerEmail}]);
    }
  }
  
  var klaviyoRetryCount = 0;
  var maxRetries = 15;
  
  function waitForKlaviyo() {
    if (window.klaviyo && (typeof window.klaviyo.identify === 'function' || Array.isArray(window.klaviyo))) {
      identifyKlaviyoUser();
    } else if (klaviyoRetryCount < maxRetries) {
      klaviyoRetryCount++;
      var scheduleCheck = window.requestIdleCallback || function(cb) { setTimeout(cb, 200); };
      scheduleCheck(waitForKlaviyo);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForKlaviyo);
  } else {
    waitForKlaviyo();
  }
}

// Export for use in theme.liquid
window.initKlaviyo = initKlaviyo;
